import { render, staticRenderFns } from "./collecttopic.vue?vue&type=template&id=767472c8&scoped=true"
import script from "./collecttopic.vue?vue&type=script&lang=js"
export * from "./collecttopic.vue?vue&type=script&lang=js"
import style0 from "./collecttopic.vue?vue&type=style&index=0&id=767472c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767472c8",
  null
  
)

export default component.exports